// dev URL
export const SERVERURL =
  "https://listool.digitivy.com/list-tool-runner/rest/titration/";
